import React from 'react';

interface PortfolioIconProps {
  className?: string;
  size?: number;
}

export const PortfolioIcon: React.FC<PortfolioIconProps> = ({ className = '', size = 24 }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 3H9C10.1046 3 11 3.89543 11 5V9C11 10.1046 10.1046 11 9 11H3V3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 13H9C10.1046 13 11 13.8954 11 15V19C11 20.1046 10.1046 21 9 21H3V13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 3H19C20.1046 3 21 3.89543 21 5V9C21 10.1046 20.1046 11 19 11H13V3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 13H19C20.1046 13 21 13.8954 21 15V19C21 20.1046 20.1046 21 19 21H13V13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

